import { render, staticRenderFns } from "./TripStatsContent.vue?vue&type=template&id=6d710a65"
import script from "./TripStatsContent.vue?vue&type=script&lang=ts"
export * from "./TripStatsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports